<template>
  <div
    v-loading="isLoading"
    class="materiral-file"
  >
    <tips-info tips="企业文件夹仅用于直接分享企业文件，无法记录用户行为轨迹（如需记录行为轨迹，请使用小程序资料）" />
    <div class="top-search">
      <div class="search-input">
        <!-- 标签多选组件 -->
        <tag-select-cascader
          v-model="levelTags"
          :disabled="isBatch"
          width="320"
          @change="tagChange"
        />
        <mk-select
          v-model="fileType"
          :disabled="isBatch"
          width="200"
          class="mr-r-10 title-input"
          placeholder="文件类型"
          clearable
          filterable
          @change="onSelectChange"
        >
          <mk-option
            v-for="item in fileTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-input
          v-model="name"
          :disabled="isBatch"
          class="title-input"
          width="240"
          clearable
          placeholder="输入文件名称"
          @keyup.enter.native="onInput"
          @clear="onInput"
        >
          <div
            slot="suffix"
            class="el-input__icon"
          >
            <i
              class="el-icon-search"
              @click="onInput"
            />
          </div>
        </mk-input>
        <mk-button-biz
          class="reset"
          :disabled="isBatch"
          @click="reset"
        >
          重置
        </mk-button-biz>
      </div>
      <div class="top-search-right">
        <mk-button-biz
          :disabled="isBatch || data.length === 0"
          class="batch cursor"
          @click="openBatchOp"
        >
          批 量
        </mk-button-biz>
        <mk-dropdown
          trigger="click"
          @command="handleCommand"
        >
          <mk-popover
            placement="left"
            trigger="hover"
            :visible-arrow="false"
            popper-class="ordinary-material-popover"
          >
            <div class="mention-text">
              <ds-iconfont icon-class="icon-ds-tishi" />
              <div class="txt">
                图片：支持JPG、PNG格式的图片，大小不超过20MB
                <br>
                视频：支持MP4格式的视频，大小不超过200MB
                <br>
                其他文件：支持常用文件类型，大小不超过20MB
              </div>
            </div>
            <!-- @click="uploadClick" -->
            <mk-button-biz
              slot="reference"
              :disabled="isBatch"
              class="upload-button"
              height="32px"
              width="104px"
              type="primary"
            >
              <ds-iconfont
                icon-class="icon-ds-shangchuan"
              />
              上传文件
            </mk-button-biz>
          </mk-popover>
          <mk-dropdown-menu slot="dropdown">
            <mk-dropdown-item command="image">
              图片
            </mk-dropdown-item>
            <mk-dropdown-item command="video">
              视频
            </mk-dropdown-item>
            <mk-dropdown-item command="file">
              其他文件
            </mk-dropdown-item>
          </mk-dropdown-menu>
        </mk-dropdown>
      </div>
    </div>
    <div
      ref="table"
      class="file-list"
    >
      <mk-table
        v-if="tableMaxHeight"
        ref="tableList"
        :max-height="tableMaxHeight"
        :data="data"
        style="width: 100%;"
        @select="fileSelectItem"
        @select-all="fileHandleOnCheckedChange"
      >
        <mk-table-column
          v-if="isBatch"
          type="selection"
          width="55"
        >
        </mk-table-column>
        <mk-table-column
          prop="fileType"
          label="类型"
          width="140"
          show-overflow-tooltip
        >
          <template v-slot="scope">
            <mk-popover
              v-if="scope.row.fileType === 6"
              popper-class="ordinary-material-img-preview-popover"
              trigger="hover"
              placement="right"
            >
              <div
                slot="reference"
                class="file-type is-image"
              >
                <mk-image
                  style="width: 36px; height: 36px;"
                  :src="scope.row.url"
                  fit="fill"
                />
                <div class="txt">
                  {{ textList[scope.row.fileType - 1] }}
                </div>
              </div>
              <img
                :src="scope.row.url"
                style="width: 150px;"
              />
            </mk-popover>
            <div
              v-else
              class="file-type"
            >
              <img :src="require('@assets/images/' + imgList[scope.row.fileType - 1] + '.png')" />
              <div class="txt">
                {{ textList[scope.row.fileType - 1] }}
              </div>
            </div>
          </template>
        </mk-table-column>
        <mk-table-column
          prop="date"
          label="文件名称"
          min-width="200"
          show-overflow-tooltip
        >
          <template v-slot="scope">
            <mk-tooltip
              effect="dark"
              content="点击编辑名称"
              placement="top"
              popper-class="ordinary-material-tooltip"
            >
              <span
                v-show="!scope.row.inputVisible"
                class="file-name"
                @click="showInput(scope.row)"
              >{{ scope.row.name + '.' + scope.row.suffix }}</span>
            </mk-tooltip>
            <!-- width="220" -->
            <mk-popover
              v-if="includeType(scope.row.suffix)"
              popper-class="error-tips-popper"
              placement="bottom-start"
              title=""
              trigger="hover"
              content="暂不支持该类型，请转换格式后上传"
            >
              <i
                slot="reference"
                class="el-icon-warning"
              ></i>
            </mk-popover>
            <div
              v-show="scope.row.inputVisible"
              class="input-wrapper"
            >
              <mk-input
                :ref="'changeNameInput' + scope.row.id"
                v-model="inputVal"
                maxlength="20"
                show-word-limit
                @blur="changeName(scope.row)"
              ></mk-input>
            </div>
          </template>
        </mk-table-column>
        <!-- 商品标签 -->
        <mk-table-column
          label="标签"
          min-width="150"
        >
          <template v-slot="scope">
            <item-show-tag :tag-list="scope.row.showTags" />
          </template>
        </mk-table-column>
        <mk-table-column
          label="大小"
          min-width="100"
        >
          <template v-slot="scope">
            {{ filter(scope.row.size) }}
          </template>
        </mk-table-column>
        <mk-table-column
          prop="createTime"
          min-width="160"
          label="上传日期"
        >
        </mk-table-column>
        <mk-table-column
          label="操作"
          width="240"
          fixed="right"
        >
          <!-- 由于mk-table-column存在【fixed="right"】导致 mk-popover 通过v-model 绑定时，不会出来，所以加做了如下处理：
            1. 去掉 v-model
            2. 添加唯一ref
            3. 通过 $refs 去关闭popover
        -->
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              class="operate"
              :disabled="isBatch"
              @click="downloadFile(scope.row)"
            >
              下载
            </mk-button-biz>
            <mk-button-biz
              :disabled="isBatch"
              type="text"
              class="operate"
              @click="showSetTagDialog(scope.row)"
            >
              标签设置
            </mk-button-biz>
            <mk-popover
              :ref="`popover-${scope.row.id}`"
              placement="top"
              trigger="click"
              popper-class="ordinary-material-delete-confirm"
            >
              <div>
                <div class="mention-text">
                  <ds-iconfont icon-class="icon-ds-tishi" />你确定删除这项素材吗？
                </div>
                <div class="button">
                  <mk-button-biz
                    width="50px"
                    height="24px"
                    @click="ordinaryDelete(scope.row.id, scope.row.directory),$refs[`popover-${scope.row.id}`].$children[0].doClose()"
                  >
                    删除
                  </mk-button-biz>
                  <mk-button-biz
                    width="50px"
                    height="24px"
                    type="primary"
                    @click="$refs[`popover-${scope.row.id}`].$children[0].doClose()"
                  >
                    取消
                  </mk-button-biz>
                </div>
              </div>
              <mk-button-biz
                slot="reference"
                :disabled="isBatch"
                type="text"
                class="operate"
              >
                删除
              </mk-button-biz>
            </mk-popover>
            <mk-image
              v-if="scope.row.suffix === 'jpg' || scope.row.suffix === 'png'"
              :ref="scope.row.id"
              class="img"
              fit="cover"
              :src="scope.row.url+'?x-oss-process=image/quality,Q_90/resize,w_600'"
              :preview-src-list="[scope.row.url]"
              style="width:0; height:0;"
            />
            <video-player
              v-if="scope.row.suffix === 'mp4' && showPreview"
              :visible.sync="showPreview"
              :url="videoUrl"
            />
            <mk-button-biz
              v-if="scope.row.suffix === 'jpg' || scope.row.suffix === 'png' || scope.row.suffix === 'mp4'"
              :disabled="isBatch"
              type="text"
              class="preview operate"
              @click="preview(scope.row)"
            >
              预览
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div
      v-if="!isBatch"
      class="pagination"
    >
      <!-- <div class="total">
        共{{ total }}条
      </div> -->
      <mk-pagination
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
    <!-- 全选操作 -->
    <footer-toolbar
      v-if="isBatch"
      class="tag-batch-op-toolbar"
      :select-all="selectAll"
      :selection="currentSelection"
      @on-checked-change="handleOnCheckedChange"
      @on-remove-click="handleOnToolbarRemoveClick"
      @on-apply-click="handleOnToolbarApplyClick"
      @on-cancel-click="handleOnToolbarCloseClick"
    />
    <!-- 是否批量删除 -->
    <mk-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>是否删除选中文件</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleOnToolbarRemoveClickCenter"
        >确 定</el-button>
      </span>
    </mk-dialog>
    <!-- 标签设置弹窗 -->
    <template>
      <set-tag-dialog
        v-if="isShowSetTagDialog"
        :visible.sync="isShowSetTagDialog"
        :type="'file'"
        :tags="tagIdList"
        @on-confirm="tagDialogConfirmFun"
        @on-close="closeDialog"
      />
    </template>
    <muti-upload
      ref="upload"
      :accept="accept"
      :limit-size="limitSize"
      file-path="material/plain/file"
      @finish="onUploadFinish"
    />
  </div>
</template>

<script>
import tipsInfo from '@components/tips-info'
import CommonData from '../common'
import MutiUpload from '../muti-upload'
import tagSelectCascader from '@components/tag-select-cascader'
import VideoPlayer from '@/components/wechat-record/components/video-player'
export default {
  name: 'MaterialImage',
  components: {
    tipsInfo,
    MutiUpload,
    tagSelectCascader,
    VideoPlayer
  },
  mixins: [CommonData],
  data () {
    return {
      videoUrl: '', // 视频预览地址
      limitSize: 20,
      accept: '',
      tableMaxHeight: 0,
      levelTags: [],
      fileTypeOptions: [
        { label: '全部', value: '' },
        { label: '文档', value: 1 },
        { label: '表格', value: 2 },
        { label: 'PDF', value: 3 },
        { label: 'TXT', value: 4 },
        { label: '幻灯片 ', value: 5 },
        { label: '图片', value: 6 },
        { label: '音频', value: 7 },
        { label: '视频', value: 8 }
      ],
      showPreview: false,
      imgList: ['word', 'xlsx', 'pdf', 'txt', 'ppt', 'image', 'mp3', 'video'],
      textList: ['文档', '表格', 'PDF', 'TXT', '幻灯片', '图片', '音频', '视频']
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.file-list', this)
    })
  },
  methods: {
    includeType (type) {
      let arr = ['jpg', 'png', 'mp4', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'txt', 'ppt', 'pptx', 'mp3', 'wma', 'wav', 'amr', 'm4a']
      let i = 0
      let len = arr.length
      let result = true
      for (i; i < len; i++) {
        if (arr[i] === type) {
          result = false
          break
        }
      }
      return result
    },
    // 预览图片/视频
    preview (data) {
      if (data.suffix === 'mp4') {
        this.showPreview = true
        this.videoUrl = data.url
      } else {
        this.$refs[data.id].$children[0].showViewer = true
      }
    },
    handleCommand (command) {
      if (command === 'image') {
        this.accept = '.jpg,.png'
        this.limitSize = 20
      } else if (command === 'video') {
        this.accept = '.mp4'
        this.limitSize = 200
      } else {
        this.accept = '.doc,.docx,.xls,.xlsx,.pdf,.txt,.ppt,.pptx,.mp3,.wma,.wav,.amr,.m4a'
        this.limitSize = 20
      }
      this.$nextTick(() => {
        this.uploadClick()
      })
    },
    /**
     * * 标签change事件
     */
    tagChange () {
      this.tags = this.util.levelTagsToTags(this.levelTags)
      this.onInput()
    },
    // 下拉框选择时候
    onSelectChange () {
      this.page = 1
      this.ordinaryListPostPost()
    },

    showInput (data) {
      let { name, id } = data
      this.inputVal = name
      this.currentVal = name
      this.currentId = id
      this.data.forEach((item, index) => {
        item.inputVisible = false
      })
      data.inputVisible = true
      this.$nextTick(() => {
        let refsName = 'changeNameInput' + data.id
        this.$refs[refsName].$children[0].focus()
      })
    },
    // 修改资料名
    async changeName (data) {
      if (!this.inputVal) {
        return this.$message.error('保存失败，名称不能为空')
      }
      if (this.currentVal === this.inputVal) {
        data.inputVisible = false
        return
      }
      let params = {
        id: this.currentId,
        name: this.inputVal,
        directory: data.directory,
        suffix: data.suffix,
        tags: data.tags || []

      }
      let res = await MKMATERIALSVC.OrdinaryApi.ordinaryPut(params)
      if (res.success) {
        this.$message.success('保存成功')
        this.ordinaryListPostPost()
      } else {
        this.$message.error('保存失败')
      }
      data.inputVisible = false
    },
    // 换算单位
    filter (size) {
      let tarSize = size / 1024 > 1024 ? Math.round(size / 1024 / 1024 * 10) / 10 + 'M' : Math.round(size / 1024) + 'KB'
      return tarSize
    },
    // 重置
    reset () {
      this.levelTags = []
      this.tags = []
      this.name = ''
      this.fileType = ''
      this.onInput()
    }
  }
}
</script>
<style lang="scss">
body {
  .ordinary-material-img-preview-popover {
    margin: 0;
    padding: 10px;
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .error-tips-popper {
    padding: 6px 10px;
  }
}
</style>
<style lang="scss" scoped>
.materiral-file {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .file-type {
    display: inline-flex;
    align-items: center;
    margin: 7px 0;

    img {
      display: block;
      width: 36px;
    }

    .txt {
      font-size: 13px;
      color: #262626;
      margin-left: 8px;
    }
  }

  .file-type.is-image {
    cursor: pointer;
  }

  .top-search {
    position: relative;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .search-input {
      display: flex;
      align-items: center;
    }

    /deep/ .tag-select {
      display: inline-block;
      margin-right: 10px;
    }

    .mr-r-10 {
      margin-right: 10px;
    }

    .top-search-right {
      display: flex;
      margin-left: 16px;

      .batch {
        border: 1px solid #ccecff;
        color: #1b9aee;
        font-size: 14px;
        line-height: 20px;
        margin-right: 10px;
        padding: 7px 14px;
        border-radius: 4px;
      }

      /deep/ .is-disabled {
        color: #d9d9d9;
        border: 1px solid #d9d9d9;
      }

      .upload-button {
        .icon-ds-shangchuan {
          color: #fff;
        }
      }
    }
  }

  .title-input {
    height: 32px !important;
    line-height: 32px !important;
    // line-height: normal !important;

    & /deep/ .el-input__inner {
      height: 32px !important;
      line-height: 32px !important;
      padding-right: 50px;
    }

    & /deep/ .el-input__suffix {
      .el-input__clear {
        position: absolute;
        top: 0;
        left: -25px;
      }
    }
  }

  .file-list {
    height: 100%;  // Todo:先注释掉，后面取消注释
    padding: 0 20px;
    margin: 10px 0;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    flex: 1;  // Todo:先注释掉，后面取消注释

    .file-name {
      cursor: pointer;

      &:hover {
        color: #009cff;
      }
    }

    .input-wrapper {
      padding: 1px 0;
    }

    .operate {
      font-weight: 400;
      color: #009cff;
      margin: 0;

      &:not(:last-child) {
        margin-right: 10px;
      }

      /deep/ span {
        font-size: 13px !important;
      }
    }
  }

  .material-list {
    height: 100%;
    overflow-y: auto;
    margin-top: 20px;
    padding-left: 30px;
  }

  .pagination {
    // height: 77px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    // border-top: 1px solid #e8e8e8;

    .total {
      color: #6d7278;
      font-size: 13px;
    }

    .mk-pagination {
      margin-top: 0;
    }
  }

  .tag-select-cascader {
    margin-right: 10px;
  }

  .reset {
    margin-left: 10px;
  }

  .preview {
    margin-left: 8px !important;
  }

  /deep/ .el-image-viewer__canvas {
    img {
      max-height: 90% !important;
      max-width: 90% !important;
    }
  }

  /deep/ .el-table__fixed-right::before,
  .el-table__fixed::before {
    z-index: 3;
  }

  .el-icon-warning {
    color: #009cff;
    cursor: pointer;
    margin-left: 5px;
  }

  .search-input {
    /deep/ .el-input__suffix {
      .el-input__clear {
        position: absolute;
        top: 0;
        left: -25px;
      }
    }
  }
}
</style>
